import React, { useState, useEffect } from "react";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import Switch from "@mui/material/Switch";
import Pagination from "@mui/material/Pagination";
import EditIcon from "@mui/icons-material/Edit";
import Stack from "@mui/material/Stack";
import { Users, User_Disable, User_Enable } from "../../services/Url";
import { Loader } from "../../Components/Loader";
import { enableUSer, post, searchData } from "../../services/Service";
import moment from "moment";

export default function UserList() {
  const [data, setData] = useState();
  const [isloading, setIsloading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  let pageData = JSON.stringify({
    search_string: searchText,
    page: page,
  });

  useEffect(() => {
    setTimeout(() => {
      post(Users, pageData, setData, setIsloading);
    }, 1500);
  }, []);

  useEffect(() => {
    searchData(Users, pageData, setData);
  }, [searchText]);

  const enableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(User_Enable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      post(Users, pageData, setData, setIsloading);
    }, 1500);
  };

  const disableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(User_Disable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      post(Users, pageData, setData, setIsloading);
    }, 1500);
  };


  const pagingHandler = (event, value) => {
    setPage(value);
    let pageData = {
      search_string: searchText,
      page: value,
    };
    pageData = JSON.stringify(pageData);
    post(Users, pageData, setData, setIsloading);
  };

  const tableData = () => {
    return (
      <TableContainer className="tbl_mn br-24 br-btm-0 ">
        <Box className="table-responsive">
          <Table className="table-design table_center">
            <TableHead>
              <TableRow className="tbl_rw">
                <TableCell className="fz-18 fw-bold">First Name</TableCell>
                <TableCell className="fz-18 fw-bold">Last Name</TableCell>
                <TableCell className="fz-18 fw-bold">Username</TableCell>
                <TableCell className="fz-18 fw-bold">Email</TableCell>
                <TableCell className="fz-18 fw-bold">Phone No</TableCell>
                <TableCell className="fz-18 fw-bold">Address</TableCell>
                <TableCell className="fz-18 fw-bold">City</TableCell>
                <TableCell className="fz-18 fw-bold">Postcode</TableCell>
                <TableCell className="fz-18 fw-bold">Country</TableCell>
                <TableCell className="fz-18 fw-bold">Registered Date</TableCell>
                <TableCell className="fz-18 fw-bold">Registered Time</TableCell>
                <TableCell className="fz-18 fw-bold">Block/ Unblock</TableCell>
                <TableCell className="fz-18 fw-bold">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.docs?.length > 0 ?
                data?.docs?.map((item, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell className="fz-16">{item.first_name}</TableCell>
                      <TableCell className="fz-16">{item.last_name}</TableCell>
                      <TableCell className="fz-16">{item.username}</TableCell>
                      <TableCell className="fz-16">{item.email}</TableCell>
                      <TableCell className="fz-16">
                        {item.phone_number}
                      </TableCell>
                      <TableCell className="fz-16">{item.address}</TableCell>
                      <TableCell className="fz-16">{item?.city}</TableCell>
                      <TableCell className="fz-16">{item?.postcode}</TableCell>
                      <TableCell className="fz-16">{item.country}</TableCell>
                      <TableCell className="fz-16">
                        {moment(item.createdAt).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell className="fz-16">
                        {moment(item.createdAt).format("LT")}
                      </TableCell>
                      <TableCell
                        className="fz-16"
                        style={{ textAlign: "center" }}
                      >
                        <Switch
                          checked={item.status}
                          onChange={() =>
                            item.status
                              ? disableUserHandler(item?._id)
                              : enableUserHandler(item?._id)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </TableCell>
                      <TableCell className="fz-16">
                      <Link to={`/edituser/${item._id}`} style={{marginRight: "8px"}}><EditIcon /></Link>
                        <Link to={`/userdetail/${item._id}`}>
                          <RemoveRedEyeIcon />
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                }) : 
                <TableRow>
                  <TableCell colSpan={12} className="empty-text">
                    No data found
                  </TableCell>
                </TableRow>
                }
            </TableBody>
          </Table>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          {data?.docs?.length > 0 ?
          <Stack spacing={2}>
            <Pagination count={data?.totalPages} onChange={pagingHandler} />
          </Stack> : ""}
        </Box>
      </TableContainer>
    );
  };

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="start"
    >
      {isloading ? <Loader /> : ""}
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">Users Management</h5>
        <Box className="table_srch mb-4">
          <TextField
            placeholder="Search User By First Name, Last Name, User Name and Email"
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Box>
      </div>
      {tableData()}
    </Box>
  );
}
